/* GARDEN EQUIPMENT — Hero carousel (rotation, crossfade, Ken Burns via CSS) */
(function () {
  "use strict";

  function pad(n) { return (n < 10 ? "0" : "") + n; }

  function initHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll(".ge-hero__slide"));
    var dots = Array.prototype.slice.call(hero.querySelectorAll("[data-ge-hero-dot]"));
    var counter = hero.querySelector("[data-ge-hero-count]");
    if (slides.length < 2) return;

    var total = slides.length;
    var index = 0;
    var paused = false;
    var timer = null;
    var rotateMs = parseInt(hero.getAttribute("data-ge-rotate") || "4200", 10);
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function show(i) {
      index = (i + total) % total;
      slides.forEach(function (s, k) {
        var active = k === index;
        s.classList.toggle("is-active", active);
        s.setAttribute("aria-hidden", active ? "false" : "true");
      });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === index); });
      if (counter) counter.textContent = pad(index + 1) + " / " + pad(total);
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function start() {
      if (reduce || paused) return;
      stop();
      timer = setInterval(next, rotateMs);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    hero.addEventListener("mouseenter", function () { paused = true; stop(); });
    hero.addEventListener("mouseleave", function () { paused = false; start(); });

    var nextBtn = hero.querySelector("[data-ge-hero-next]");
    var prevBtn = hero.querySelector("[data-ge-hero-prev]");
    if (nextBtn) nextBtn.addEventListener("click", function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        show(parseInt(d.getAttribute("data-ge-hero-dot"), 10));
        start();
      });
    });

    show(0);
    start();
  }

  function boot() {
    document.querySelectorAll("[data-ge-hero]").forEach(initHero);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
